import { COMPONENT, register } from '~/core/repository'
import { PlayerWindow } from './components/PlayerWindow'

export { EpgPage, Title } from './page'

// register `PlayerWindow` componnt to use in skin
register(PlayerWindow, 'PlayerWindow', COMPONENT)
